export default __webpack_public_path__ + "static/media/Dubstep_call_tone.mp3.3b3a2f5f.mpeg";